import { instantLottoState } from '@/types/instant';

const state: instantLottoState = {
    totalInstant: 0,
    cartInstant: [],
};

export default state;
